import { render } from "./ModalBorrar.vue?vue&type=template&id=602589dc"
import script from "./ModalBorrar.vue?vue&type=script&lang=js"
export * from "./ModalBorrar.vue?vue&type=script&lang=js"

import "./ModalBorrar.vue?vue&type=style&index=0&id=602589dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__